export default "__VITE_ASSET__c83fe613__"